// extracted by mini-css-extract-plugin
export default {"label":"trueFalse_label__D0+Pl"};